var _path, _path2, _path3, _path4, _g, _g2, _g3, _g4, _g5, _g6, _g7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgM05(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1562_2881)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0889 19.166C17.0015 19.1659 16.9163 19.1384 16.8455 19.0872C16.7746 19.0361 16.7216 18.9639 16.6939 18.881L15.9752 16.7248C15.9498 16.6499 15.9462 16.5694 15.9649 16.4926C15.9836 16.4158 16.0237 16.3459 16.0806 16.291C16.1548 16.2198 16.2281 16.1464 16.2994 16.0723C16.354 16.0157 16.4236 15.9759 16.5 15.9572C16.5763 15.9386 16.6565 15.9419 16.731 15.9668L18.8873 16.6856C18.9923 16.7205 19.0791 16.7957 19.1286 16.8946C19.1781 16.9936 19.1864 17.1081 19.1514 17.2131C19.1165 17.3181 19.0413 17.4049 18.9424 17.4544C18.8435 17.504 18.7289 17.5122 18.6239 17.4773L16.9156 16.9081L17.4848 18.6164C17.5059 18.6792 17.5118 18.746 17.5019 18.8115C17.492 18.877 17.4667 18.9391 17.428 18.9929C17.3893 19.0466 17.3383 19.0903 17.2794 19.1204C17.2204 19.1505 17.1551 19.1662 17.0889 19.166Z",
    fill: "url(#paint0_linear_1562_2881)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.92674 19.1666C2.86075 19.1666 2.79572 19.1508 2.737 19.1207C2.67828 19.0906 2.62755 19.047 2.58898 18.9935C2.55041 18.94 2.52511 18.878 2.51516 18.8128C2.5052 18.7476 2.51089 18.6809 2.53174 18.6183L3.10091 16.9099L1.39257 17.4795C1.28759 17.5145 1.17304 17.5062 1.07411 17.4567C0.975188 17.4072 0.899994 17.3203 0.865074 17.2154C0.830154 17.1104 0.838368 16.9958 0.887909 16.8969C0.93745 16.798 1.02426 16.7228 1.12924 16.6879L3.28549 15.9687C3.36019 15.9438 3.44043 15.9405 3.5169 15.9593C3.59338 15.9781 3.66295 16.0182 3.71757 16.075C3.78882 16.1487 3.86132 16.2216 3.93507 16.2929C3.99181 16.3475 4.0319 16.4171 4.0507 16.4935C4.06951 16.57 4.06626 16.6502 4.04132 16.7249L3.32174 18.8816C3.29412 18.9646 3.24111 19.0367 3.17022 19.0878C3.09933 19.139 3.01415 19.1666 2.92674 19.1666Z",
    fill: "url(#paint1_linear_1562_2881)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42708 3.55859C4.05793 4.53076 3.03335 5.9131 2.50143 7.50582C1.96952 9.09854 1.95782 10.8191 2.46802 12.419C2.97822 14.0188 3.9839 15.4149 5.33971 16.4056C6.69552 17.3963 8.33122 17.9302 10.0104 17.9302C11.6896 17.9302 13.3253 17.3963 14.6811 16.4056C16.0369 15.4149 17.0426 14.0188 17.5528 12.419C18.063 10.8191 18.0513 9.09854 17.5194 7.50582C16.9875 5.9131 15.9629 4.53076 14.5937 3.55859V6.66609C14.5937 7.88167 14.1109 9.04746 13.2513 9.907C12.3918 10.7665 11.226 11.2494 10.0104 11.2494C8.79484 11.2494 7.62905 10.7665 6.76951 9.907C5.90997 9.04746 5.42708 7.88167 5.42708 6.66609V3.55859Z",
    fill: "url(#paint2_linear_1562_2881)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0104 8.33333C10.9309 8.33333 11.6771 7.58714 11.6771 6.66667C11.6771 5.74619 10.9309 5 10.0104 5C9.08994 5 8.34375 5.74619 8.34375 6.66667C8.34375 7.58714 9.08994 8.33333 10.0104 8.33333Z",
    fill: "url(#paint3_linear_1562_2881)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -5.75,
    y: -11.584,
    width: 31.5,
    height: 34
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6px)",
      clipPath: "url(#bgblur_1_1562_2881_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1562_2881)",
    "data-figma-bg-blur-radius": 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0.41602C8.71112 0.414746 7.43539 0.674996 6.25 1.18102V6.66602C6.25 7.66058 6.64509 8.61441 7.34835 9.31767C8.05161 10.0209 9.00544 10.416 10 10.416C10.9946 10.416 11.9484 10.0209 12.6516 9.31767C13.3549 8.61441 13.75 7.66058 13.75 6.66602V1.18102C12.5646 0.674996 11.2889 0.414746 10 0.41602Z",
    fill: "url(#paint4_linear_1562_2881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99902 0.916016H10.001C11.1129 0.914976 12.2139 1.12097 13.25 1.51953V6.66602C13.25 7.52797 12.9073 8.35437 12.2979 8.96387C11.6884 9.57336 10.862 9.91602 10 9.91602C9.13805 9.91602 8.31164 9.57336 7.70215 8.96387C7.09266 8.35437 6.75 7.52797 6.75 6.66602V1.51953C7.78607 1.12097 8.88707 0.914975 9.99902 0.916016Z",
    stroke: "url(#paint5_linear_1562_2881)",
    strokeOpacity: 0.1
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: -11.5781,
    y: -11.584,
    width: 43.168,
    height: 43.1665
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(6px)",
      clipPath: "url(#bgblur_2_1562_2881_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1562_2881)",
    "data-figma-bg-blur-radius": 12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0052 19.5827C15.2979 19.5827 19.5885 15.2921 19.5885 9.99935C19.5885 4.70662 15.2979 0.416016 10.0052 0.416016C4.71248 0.416016 0.421875 4.70662 0.421875 9.99935C0.421875 15.2921 4.71248 19.5827 10.0052 19.5827Z",
    fill: "#1D1D1D",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0052 19.5827C15.2979 19.5827 19.5885 15.2921 19.5885 9.99935C19.5885 4.70662 15.2979 0.416016 10.0052 0.416016C4.71248 0.416016 0.421875 4.70662 0.421875 9.99935C0.421875 15.2921 4.71248 19.5827 10.0052 19.5827Z",
    fill: "url(#paint6_linear_1562_2881)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0049 0.916016C15.0214 0.916016 19.0887 4.98259 19.0889 9.99902C19.0889 15.0156 15.0215 19.083 10.0049 19.083C4.98845 19.0828 0.921875 15.0155 0.921875 9.99902C0.922051 4.9827 4.98855 0.916191 10.0049 0.916016Z",
    stroke: "url(#paint7_linear_1562_2881)",
    strokeOpacity: 0.1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1562_2881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0.41602C8.71112 0.414746 7.43539 0.674996 6.25 1.18102V6.66602C6.25 7.66058 6.64509 8.61441 7.34835 9.31767C8.05161 10.0209 9.00544 10.416 10 10.416C10.9946 10.416 11.9484 10.0209 12.6516 9.31767C13.3549 8.61441 13.75 7.66058 13.75 6.66602V1.18102C12.5646 0.674996 11.2889 0.414746 10 0.41602Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_1562_2881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.25 2.10623V3.0304C7.40218 2.40875 8.69082 2.08329 10 2.08329C11.3092 2.08329 12.5978 2.40875 13.75 3.0304V2.10623C12.5802 1.54266 11.2985 1.25 10 1.25C8.70154 1.25 7.41978 1.54266 6.25 2.10623Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_1562_2881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.59074 13.829C5.66888 13.7509 5.77484 13.707 5.88533 13.707C5.99581 13.707 6.10177 13.7509 6.17991 13.829C7.19572 14.8448 8.5734 15.4154 10.0099 15.4154C11.4464 15.4154 12.8241 14.8448 13.8399 13.829C13.9185 13.7531 14.0237 13.7111 14.133 13.7121C14.2422 13.713 14.3467 13.7568 14.424 13.8341C14.5013 13.9114 14.5451 14.0159 14.546 14.1251C14.547 14.2344 14.505 14.3396 14.4291 14.4182C13.257 15.5901 11.6674 16.2485 10.0099 16.2485C8.35243 16.2485 6.76283 15.5901 5.59074 14.4182C5.51263 14.3401 5.46875 14.2341 5.46875 14.1236C5.46875 14.0131 5.51263 13.9072 5.59074 13.829Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_1562_2881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5885 1.58594V2.5601C16.2116 3.55818 17.4646 5.0588 18.157 6.83395C18.8494 8.6091 18.9435 10.5618 18.4249 12.3952C17.9062 14.2287 16.8033 15.8428 15.2836 16.9923C13.764 18.1417 11.9106 18.7637 10.0052 18.7637C8.0998 18.7637 6.24645 18.1417 4.72678 16.9923C3.20711 15.8428 2.10418 14.2287 1.58556 12.3952C1.06694 10.5618 1.16099 8.6091 1.85341 6.83395C2.54583 5.0588 3.79878 3.55818 5.42188 2.5601V1.58594C3.55121 2.60467 2.07326 4.2176 1.22147 6.16994C0.369682 8.12229 0.192613 10.3028 0.718232 12.367C1.24385 14.4312 2.4422 16.2614 4.12399 17.5687C5.80577 18.8759 7.87514 19.5855 10.0052 19.5855C12.1353 19.5855 14.2047 18.8759 15.8864 17.5687C17.5682 16.2614 18.7666 14.4312 19.2922 12.367C19.8178 10.3028 19.6407 8.12229 18.789 6.16994C17.9372 4.2176 16.4592 2.60467 14.5885 1.58594Z",
    fill: "white",
    fillOpacity: 0.1
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_1562_2881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0104 8.33333C10.9309 8.33333 11.6771 7.58714 11.6771 6.66667C11.6771 5.74619 10.9309 5 10.0104 5C9.08994 5 8.34375 5.74619 8.34375 6.66667C8.34375 7.58714 9.08994 8.33333 10.0104 8.33333Z",
    fill: "white",
    fillOpacity: 0.1
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1562_2881",
    x: -5.75,
    y: -11.584,
    width: 31.5,
    height: 34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1562_2881"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_1562_2881_clip_path",
    transform: "translate(5.75 11.584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0.41602C8.71112 0.414746 7.43539 0.674996 6.25 1.18102V6.66602C6.25 7.66058 6.64509 8.61441 7.34835 9.31767C8.05161 10.0209 9.00544 10.416 10 10.416C10.9946 10.416 11.9484 10.0209 12.6516 9.31767C13.3549 8.61441 13.75 7.66058 13.75 6.66602V1.18102C12.5646 0.674996 11.2889 0.414746 10 0.41602Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1562_2881",
    x: -11.5781,
    y: -11.584,
    width: 43.168,
    height: 43.1665,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1562_2881"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_1562_2881_clip_path",
    transform: "translate(11.5781 11.584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0052 19.5827C15.2979 19.5827 19.5885 15.2921 19.5885 9.99935C19.5885 4.70662 15.2979 0.416016 10.0052 0.416016C4.71248 0.416016 0.421875 4.70662 0.421875 9.99935C0.421875 15.2921 4.71248 19.5827 10.0052 19.5827Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1562_2881",
    x: 6.25,
    y: 0.416016,
    width: 7.5,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1562_2881"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_1562_2881",
    x: 6.25,
    y: 1.25,
    width: 7.5,
    height: 3.78027,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1562_2881"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_1562_2881",
    x: 5.46875,
    y: 13.707,
    width: 9.07812,
    height: 4.5415,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1562_2881"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_1562_2881",
    x: 0.421875,
    y: 1.58594,
    width: 19.168,
    height: 19.9995,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1562_2881"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_1562_2881",
    x: 8.34375,
    y: 5,
    width: 3.33203,
    height: 5.3335,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1562_2881"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1562_2881",
    x1: 15.9531,
    y1: 15.9453,
    x2: 19.7459,
    y2: 16.9081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ba6be7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1562_2881",
    x1: 0.84375,
    y1: 15.9473,
    x2: 4.63569,
    y2: 16.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ba6be7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1562_2881",
    x1: 2.09375,
    y1: 3.55859,
    x2: 20.5065,
    y2: 8.70946,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ba6be7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1562_2881",
    x1: 8.34375,
    y1: 5,
    x2: 12.2703,
    y2: 5.99703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ba6be7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1562_2881",
    x1: 6.25,
    y1: 0.416016,
    x2: 15.3253,
    y2: 2.1443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ba6be7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703125,
    stopColor: "#2C32FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1562_2881",
    x1: 6.48438,
    y1: 0.870561,
    x2: 13.75,
    y2: 0.870561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1562_2881",
    x1: 0.421875,
    y1: 0.416016,
    x2: 22.9996,
    y2: 6.14892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87FFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776042,
    stopColor: "#5C6DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1562_2881",
    x1: 1.02083,
    y1: 1.28723,
    x2: 19.5885,
    y2: 1.28723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CDEB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65625,
    stopColor: "#364AFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1562_2881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM05);
export default __webpack_public_path__ + "static/media/m_05.f6d73453611763d9e30276b273c9a8f4.svg";
export { ForwardRef as ReactComponent };